import { useState, useEffect, useRef } from "react";
export default function ServicesSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);
  const services = [{
    title: "Website Design",
    description: "Custom websites designed to build trust and convert visitors into customers. Beautiful, fast, and built for results.",
    iconBg: "#3B82F6",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect width="20" height="14" x="2" y="3" rx="2"></rect><line x1="8" x2="16" y1="21" y2="21"></line><line x1="12" x2="12" y1="17" y2="21"></line></svg>
  }, {
    title: "Local SEO",
    description: "Help local businesses rank higher on Google Maps and local search results with data-driven SEO strategies.",
    iconBg: "#10B981",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg>
  }, {
    title: "Google Business Profile",
    description: "Increase visibility, reviews, and local leads through expert GBP optimization and management.",
    iconBg: "#8B5CF6",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path><path d="M2 12h20"></path></svg>
  }, {
    title: "Digital Marketing",
    description: "Targeted campaigns that drive traffic, leads, and growth through proven multi-channel strategies.",
    iconBg: "#F59E0B",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="3" y="3" width="4" height="18" rx="1"></rect><rect x="10" y="8" width="4" height="13" rx="1"></rect><rect x="17" y="5" width="4" height="16" rx="1"></rect></svg>
  }, {
    title: "Website Maintenance",
    description: "Security updates, backups, monitoring, and ongoing support to keep your website running smoothly.",
    iconBg: "#EC4899",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
  }, {
    title: "Conversion Optimization",
    description: "Improve calls, form submissions, and customer inquiries through data-backed optimization.",
    iconBg: "#06B6D4",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline><polyline points="16 7 22 7 22 13"></polyline></svg>
  }];
  return <section ref={sectionRef} style={{
    backgroundColor: "rgb(255, 255, 255)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(2, 8, 23)",
    fontFamily: '"DM Sans", sans-serif',
    animation: "none 0s ease 0s 1 normal none running"
  }} className="w-full">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700&family=DM+Sans:wght@400;500;600&display=swap');

        @keyframes fade-in-up {
          0% { opacity: 0; transform: translateY(24px); }
          100% { opacity: 1; transform: translateY(0px); }
        }

        .service-card-animate {
          opacity: 0;
          transform: translateY(24px);
          transition: opacity 0.6s ease, transform 0.6s ease;
        }

        .service-card-animate.visible {
          opacity: 1;
          transform: translateY(0px);
        }

        .learn-more-link:hover {
          opacity: 0.75;
        }

        .view-all-btn:hover {
          background-color: #F8FAFC;
          transform: scale(1.02);
        }

        .grow-online-gradient {
          background: linear-gradient(90deg, #2563EB 0%, #06B6D4 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      `}</style>

      <div style={{
      paddingTop: "112px",
      paddingBottom: "112px"
    }} className="px-4 md:px-6">
        <div className="page-container">
          <div className={`flex flex-col items-center text-center mb-16 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="inline-flex items-center gap-1.5 mb-4" style={{
            border: "1px solid #E2E8F0",
            borderRadius: "9999px",
            backgroundColor: "#FFFFFF",
            boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
            paddingTop: "6px",
            paddingBottom: "6px",
            paddingLeft: "12px",
            paddingRight: "12px"
          }}>
              <span style={{
              color: "#64748B",
              display: "flex",
              alignItems: "center"
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"></path><path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"></path><path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"></path></svg>
              </span>
              <span style={{
              color: "#64748B",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "14px",
              fontWeight: "500"
            }}>
                Our Services
              </span>
            </div>

            <h2 style={{
            color: "rgb(30, 41, 59)",
            fontFamily: "Outfit, sans-serif",
            fontSize: "48px",
            fontWeight: "700",
            lineHeight: "1.15",
            letterSpacing: "-1.2px",
            border: "0px solid rgb(226, 232, 240)",
            textAlign: "center",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "16px"
          }} className="max-w-3xl">
              Everything Your Local Business Needs to{" "}
              <span className="grow-online-gradient">Grow Online</span>
            </h2>

            <p style={{
            color: "rgb(100, 116, 139)",
            fontFamily: '"DM Sans", sans-serif',
            fontSize: "18px",
            fontWeight: "400",
            lineHeight: "29.25px",
            border: "0px solid rgb(226, 232, 240)",
            textAlign: "center",
            animation: "none 0s ease 0s 1 normal none running",
            maxWidth: "600px"
          }}>
              From building a stunning website to dominating local search results, we offer
              comprehensive digital solutions tailored for local service businesses.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {services.map((service, index) => <div key={service.title} className={`service-card-animate flex flex-col${visible ? " visible" : ""}`} style={{
            transitionDelay: `${index * 100}ms`
          }}>
                <div style={{
              width: "48px",
              height: "48px",
              borderRadius: "12px",
              backgroundColor: service.iconBg,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              marginBottom: "20px"
            }}>
                  {service.icon}
                </div>

                <h3 style={{
              color: "rgb(30, 41, 59)",
              fontFamily: "Outfit, sans-serif",
              fontSize: "20px",
              fontWeight: "600",
              lineHeight: "28px",
              border: "0px solid rgb(226, 232, 240)",
              animation: "none 0s ease 0s 1 normal none running",
              marginBottom: "8px"
            }}>
                  {service.title}
                </h3>

                <p style={{
              color: "rgb(100, 116, 139)",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "16px",
              fontWeight: "400",
              lineHeight: "26px",
              border: "0px solid rgb(226, 232, 240)",
              animation: "none 0s ease 0s 1 normal none running",
              marginBottom: "16px",
              flexGrow: 1
            }}>
                  {service.description}
                </p>

                <a href="#" className="learn-more-link inline-flex items-center gap-1 transition-opacity duration-150" style={{
              color: "rgb(37, 99, 235)",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "20px",
              border: "0px solid rgb(226, 232, 240)",
              animation: "none 0s ease 0s 1 normal none running",
              textDecoration: "none"
            }}>
                  Learn more
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgb(37, 99, 235)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"></path></svg>
                </a>
              </div>)}
          </div>

          <div className={`flex justify-center mt-14 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "700ms"
        }}>
            <a href="#" className="view-all-btn inline-flex items-center gap-2 transition-all duration-200 cursor-pointer" style={{
            border: "1px solid #E2E8F0",
            borderRadius: "9999px",
            backgroundColor: "transparent",
            paddingTop: "12px",
            paddingBottom: "12px",
            paddingLeft: "28px",
            paddingRight: "28px",
            color: "#1E293B",
            fontFamily: '"DM Sans", sans-serif',
            fontSize: "16px",
            fontWeight: "500",
            lineHeight: "1.5",
            textDecoration: "none",
            height: "48px"
          }}>
              View All Services
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1E293B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>
            </a>
          </div>
        </div>
      </div>
    </section>;
}